import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains core information about any person mentioned in this system. This includes employees, students, alumni, donors, collaborators from another institution, etc.',
    name: 'People',
    partialId: PartialId.Standard.create('people'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
